import { InstrumentDefinitionAndInitialValues } from '@app/core/store/capital-structure-slice-selectors';
import { calculateCapitalStructureDimensions } from '@app/modules/projects/inputs/capital-structure/capital-structure-block-size-calculator';
import { Instrument } from '@app/modules/projects/inputs/capital-structure/capital-structure-types';
import { groupBy } from '@app/shared/helpers/group-by';
import { OpmForecastDto } from '@app/shared/models/contracts/opm-calculation-results-dto';

export const createStructureForInstruments = <T extends Instrument>(instruments: T[]) =>
  calculateCapitalStructureDimensions(instruments, 100, 100, 0, 0, false);

const getOpmForecastByYear = (forecastYear: string, forecastData: OpmForecastDto[]) =>
  forecastData.find((forecast) => forecast.forecastDate === forecastYear);

export const getStructureForForecastStack = (
  forecastYear: string,
  forecastData: OpmForecastDto[],
  allInstruments: InstrumentDefinitionAndInitialValues[]
) => {
  const forecast = getOpmForecastByYear(forecastYear, forecastData);
  const distributions = forecast?.instrumentDistributions ?? [];
  const distributionsByInstrument = groupBy(distributions, (x) => x.instrumentId!);

  return createStructureForInstruments(
    Object.values(distributionsByInstrument).map((ins) => {
      const definitionAndInitialValues = allInstruments.find(
        (item) => item.instrumentId === ins[0].instrumentId
      );
      return {
        ...definitionAndInitialValues!,
        amount: ins[0].distributionAmount,
      };
    })
  );
};
